// extracted by mini-css-extract-plugin
module.exports = {"mathWorkingInteraction":"mathWorking__mathWorkingInteraction___h26_e","isTooWide":"mathWorking__isTooWide___3P0Lv","message":"mathWorking__message___2Tt2W"};